import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { LogIn, Lock } from "lucide-react";
import { login, getToken } from "../../lib/auth";
import { toast } from "sonner";
import Logo from "../../components/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (getToken()) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo!");
      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Falha no login";
      toast.error(typeof msg === "string" ? msg : "Falha no login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#0F0F10] text-white flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="mb-12 flex justify-center">
          <Logo variant="light" size={44} />
        </div>
        <div className="bg-white text-[#1A1A1A] p-8 md:p-10 border-t-4 border-[#E84E34]">
          <div className="flex items-center gap-3 mb-2">
            <Lock size={20} className="text-[#E84E34]" />
            <div className="font-mono-sm text-[10px] tracking-[0.3em] uppercase text-[#6B7280]">// PAINEL ADMIN</div>
          </div>
          <h1 className="font-display text-3xl font-black mt-2">Acesso restrito</h1>
          <p className="mt-2 text-sm text-[#6B7280]">Entre com suas credenciais administrativas.</p>

          <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <label className="block font-mono-sm text-[10px] tracking-[0.25em] uppercase text-[#6B7280] mb-2">E-mail</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email"
                className="w-full bg-white border border-[#E5E7EB] focus:border-[#1A1A1A] outline-none px-4 py-3 text-sm rounded-none"
                placeholder="admin@avantech.inf.br"
              />
            </div>
            <div>
              <label className="block font-mono-sm text-[10px] tracking-[0.25em] uppercase text-[#6B7280] mb-2">Senha</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password"
                className="w-full bg-white border border-[#E5E7EB] focus:border-[#1A1A1A] outline-none px-4 py-3 text-sm rounded-none"
                placeholder="••••••••"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-3 bg-[#E84E34] text-white font-bold px-7 py-4 uppercase text-xs tracking-[0.2em] hover:bg-[#CF412A] transition-colors disabled:opacity-60"
            >
              {loading ? "Entrando..." : "Entrar"} <LogIn size={16} />
            </button>
          </form>
        </div>
        <a href="/" className="block text-center mt-8 text-xs font-mono-sm tracking-[0.2em] uppercase text-white/50 hover:text-white">
          ← Voltar ao site
        </a>
      </div>
    </main>
  );
}
